(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-products"] && !Shopify.designMode) return;
  try {
    // A Conectiv production line and its test-pressing line are removed together: one
  // `/cart/update.js` call zeroes every key the button lists (the production line and every line
  // sharing its `_Conectiv draft key`, gathered in Liquid above), then the page reloads so the
  // cart, the drawer and the header count all show the cart Shopify now holds. Delegated from
  // the document once, so it keeps working after the cart re-renders.
  document.addEventListener('click', async (event) => {
    const target = event.target instanceof Element ? event.target : null;
    const button = target?.closest('[data-conectiv-remove-keys]');
    if (!(button instanceof HTMLButtonElement) || button.disabled) return;
    event.preventDefault();

    const keys = String(button.dataset.conectivRemoveKeys || '')
      .split(',')
      .map((key) => key.trim())
      .filter(Boolean);
    if (keys.length === 0) return;

    const updates = {};
    for (const key of keys) updates[key] = 0;
    const root = window.Shopify?.routes?.root || '/';

    button.disabled = true;
    try {
      const response = await fetch(`${root.replace(/\/$/, '')}/cart/update.js`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates }),
      });
      if (!response.ok) throw new Error(`Cart update answered ${response.status}`);
      window.location.reload();
    } catch (error) {
      console.error('Could not remove this project from the cart.', error);
      button.disabled = false;
      window.alert('We couldn’t remove this project from your cart. Please try again.');
    }
  });
  } catch(e) { console.error(e); }
})();

})();
